export default __webpack_public_path__ + "static/media/groupRank.e2969f5b.svg";